import configsProduction from 'env.json'

const exportEnv = (call) => {
  if (configsProduction?.NODE_ENV === 'production') {
    window.env = configsProduction
    call({ code: 1, msg: 'Enviroment loaded on build time' })
  } else {
    fetch('/local.env').then(response => {
      if (!response.ok) throw new Error(`HTTP ${response.status} ${response.statusText}`)
      return response.json()
    }).then(data => {
      window.env = data
      call({ code: 1, msg: 'Enviroment loaded on client side' })
    }).catch(error => {
      console.log(
        `%c ${error.message} `,
        'background-color: blue; color: white; font-weight: bold; font-size: 1.3rem;'
      )
      console.log(
        '%c "/local.env" file not found ',
        'background-color: red; color: white; font-weight: bold; font-size: 1.3rem;'
      )
      call({ code: 0, msg: 'Error on load environment variables, please check console to more informations' })
    })
  }
}

export default exportEnv
